var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"n-v-chip-attachment",attrs:{"outlined":"","color":"blue-grey","dark":"","label":"","close":""},on:{"click:close":_vm.removeAttachment}},[_vm._v(" "+_vm._s(_vm.name)+" ( "+_vm._s(_vm.readableSize)+" ) ")])
}
var staticRenderFns = []

export { render, staticRenderFns }